import request from './request';

/**
 * Decision Engine API — 决策引擎服务层
 */
export const decisionAPI = {
  /**
   * 解析用户意图
   * POST /decision/intent
   */
  parseIntent: (query) => request.post('/decision/intent', { query }),

  /**
   * 执行完整决策链路
   * POST /decision/decide
   */
  decide: (query, context) => request.post('/decision/decide', { query, context }),

  /**
   * 运行仿真校验
   * POST /decision/simulate
   */
  simulate: (planId) => request.post('/decision/simulate', { planId }),

  /**
   * 获取决策解释
   * GET /decision/explain/:candidateId
   */
  explain: (candidateId) => request.get(`/decision/explain/${candidateId}`),

  /**
   * 前端兜底 Mock — 后端不可用时使用
   */
  mockDecide: (query) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const isJapanese = /日料|日本料理/.test(query);
        resolve({
          decisionId: 'dec_' + Date.now(),
          query,
          intent: {
            intents: [{ type: 'scenario', value: 'romantic_date', confidence: 0.95 }],
            constraints: { budget: 500, cuisine: isJapanese ? 'japanese' : null, tags: ['scenic_view', 'quiet', 'walkable'] },
          },
          candidates: [
            { id: 'c1', name: '星空日料·外滩店', type: '怀石料理', rating: 4.9, price: '¥380/人', distance: '2.3km', highlight: '12楼露台景观', score: 94, confidence: 0.92, riskLevel: 'LOW' },
            { id: 'c2', name: '醍醐·高空景观', type: '怀石料理', rating: 4.8, price: '¥420/人', distance: '1.8km', highlight: '高层夜景', score: 88, confidence: 0.87, riskLevel: 'LOW' },
            { id: 'c3', name: '花见·南京西路', type: '居酒屋', rating: 4.6, price: '¥280/人', distance: '3.1km', highlight: '亲民氛围', score: 82, confidence: 0.85, riskLevel: 'MEDIUM' },
          ],
          constraints: [
            { constraint: '预算 ¥500', passed: true },
            { constraint: '餐饮类型', passed: true },
            { constraint: '夜景视野', passed: true },
            { constraint: '环境安静', passed: true },
            { constraint: '步行可达', passed: false },
          ],
          riskAssessment: { overall: 'LOW', items: [
            { type: '交通', level: 'LOW', desc: '地铁直达' },
            { type: '排队', level: 'MEDIUM', desc: '周末晚高峰建议早到' },
            { type: '天气', level: 'LOW', desc: '无降雨预警' },
          ]},
        });
      }, 800);
    });
  },
};

export default decisionAPI;
